import React from 'react';
import styles from './StatusBadge.module.css';

const STATUS_CONFIG = {
    // Purchase Order Status
    pending: { label: 'Pendente', className: 'statusBadgePending' },
    approved: { label: 'Aprovado', className: 'statusBadgeApproved' },
    completed: { label: 'Concluído', className: 'statusBadgeCompleted' },
    cancelled: { label: 'Cancelado', className: 'statusBadgeCancelled' },
    rejected: { label: 'Rejeitado', className: 'statusBadgeRejected' },

    // Sales Order Status
    draft: { label: 'Rascunho', className: 'statusBadgeDraft' },
    in_production: { label: 'Em Produção', className: 'statusBadgeInfo' },
    production_completed: { label: 'Produção Concluída', className: 'statusBadgeCompleted' },
    ready_for_picking: { label: 'Pronto para Separação', className: 'statusBadgeInfo' },
    shipped: { label: 'Enviado', className: 'statusBadgeInfo' },
    delivered: { label: 'Entregue', className: 'statusBadgeCompleted' },

    // Receiving Status
    pending_entry: { label: 'Aguardando Entrada', className: 'statusBadgeInfo' },
    partially_received: { label: 'Recebimento Parcial', className: 'statusBadgeWarning' },
    fully_received: { label: 'Totalmente Recebido', className: 'statusBadgeSuccess' },

    // Generic
    info: { label: 'Info', className: 'statusBadgeInfo' },
    warning: { label: 'Aviso', className: 'statusBadgeWarning' },
    success: { label: 'Sucesso', className: 'statusBadgeSuccess' },
    danger: { label: 'Erro', className: 'statusBadgeDanger' },
};

const StatusBadge = ({ status, customLabel, className = '' }) => {
    const config = STATUS_CONFIG[status];
    const label = customLabel || config?.label || status || 'Desconhecido';
    const badgeClass = config?.className || 'statusBadgePending';

    return (
        <span className={`${styles.statusBadge} ${styles[badgeClass]} ${className}`}>
            {label}
        </span>
    );
};

export default StatusBadge;